module.exports = __webpack_public_path__ + "static/img02__pc-6a13c707bee545160a60e1b3d2125282.svg";